export function getDownloadURL(videoId) {
    return (typeof spottDownloadUrls !=='undefined'  && spottDownloadUrls['urls'][videoId])
        ? `${spottDownloadUrls.host}${spottDownloadUrls.urls[videoId]}`
        : '';
}
export function initPlayer(containerId, videoId, autoPlay = false)
{
    const consent = OnetrustActiveGroups?.includes('2');
    window.utag = window.utag || {};
    window.utag.gdpr = window.utag.gdpr || {};
    window.utag.gdpr.getSelectedCategories = () => consent ? ['analytics'] : [];
    return new avvpl.setupPlayer(getDefaultConfig(containerId, videoId, autoPlay));
}
window.initPlayer = initPlayer;

export function getConfigUrl(videoId, autoPlay=false, showTitle=false)
{
    return `${currentEnvironment.spottEndpoint}/content/${videoId}/player-setting?autoplay=${autoPlay}&showTitle=${showTitle}`
}

export function getDefaultConfig(containerId, videoId, autoPlay = false)
{
    return {
        id: containerId,
        configUrl: getConfigUrl(videoId, autoPlay),
        "allowDVR": true,
        downloadVideoUrl: getDownloadURL(videoId),
        skin: {
            theme: 1,
            customLayout: {
                controlsLeft: ["rewind/1"]
            }
        }
    };
}
$(function () {
    $(".btd-module-video").each(function (_, videoModule) {
        const $videoModule = $(videoModule);
        const videoPlayerId = $('.video-container', $videoModule).data('id');
        const playerIdArray = videoPlayerId.split('_');
        const videoId = playerIdArray[playerIdArray.length - 1];
        const $loader = $('.loading', $videoModule);
        if(videoId){
            initPlayer(videoPlayerId, videoId, false);
        }
   });
});





